import {
  DashboardOutlined,
  UserSwitchOutlined,
  ShoppingOutlined,
  BankOutlined,
  BlockOutlined,
  UnorderedListOutlined,
  CarOutlined,
  UsergroupAddOutlined,
  ContainerOutlined,
  SettingOutlined,
  ReconciliationOutlined,
  AreaChartOutlined,
  DollarOutlined,
  PictureOutlined,
  MobileOutlined,
  InboxOutlined,
  DatabaseOutlined,
  BarcodeOutlined,
  PercentageOutlined,
  TagsOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig';
import { RoleName } from 'domain/User';
import type { FunctionComponent } from 'react';

export interface NavItem {
  key: string;
  path?: string;
  title: string;
  icon?: FunctionComponent;
  breadcrumb: boolean;
  roles: RoleName[];
  submenu?: NavItem[];
}

const navigationConfig: NavItem[] = [
  {
    key: 'shop',
    title: 'Sklep',
    breadcrumb: false,
    roles: [RoleName.WAREHOUSEMAN, RoleName.ADMIN, RoleName.VENDOR],
    submenu: [
      {
        key: 'orders',
        path: `${APP_PREFIX_PATH}/orders`,
        title: 'Zamówienia',
        icon: DashboardOutlined,
        breadcrumb: false,
        roles: [RoleName.VENDOR, RoleName.WAREHOUSEMAN, RoleName.ADMIN],
      },
      {
        key: 'taken-from-warehouse',
        path: `${APP_PREFIX_PATH}/taken-from-warehouse`,
        title: 'Zabrane z magazynu',
        icon: InboxOutlined,
        breadcrumb: false,
        roles: [RoleName.VENDOR, RoleName.WAREHOUSEMAN, RoleName.ADMIN],
      },
      {
        key: 'warehouse-inventories',
        path: `${APP_PREFIX_PATH}/warehouse-inventories`,
        title: 'Remanenty',
        icon: BarcodeOutlined,
        breadcrumb: false,
        roles: [RoleName.WAREHOUSEMAN, RoleName.ADMIN],
      },
      {
        key: 'clients',
        path: `${APP_PREFIX_PATH}/clients`,
        title: 'Klienci',
        icon: UserSwitchOutlined,
        breadcrumb: false,
        roles: [RoleName.VENDOR, RoleName.WAREHOUSEMAN, RoleName.ADMIN],
      },
      {
        key: 'products',
        path: `${APP_PREFIX_PATH}/products`,
        title: 'Produkty',
        icon: ShoppingOutlined,
        breadcrumb: false,
        roles: [RoleName.VENDOR, RoleName.WAREHOUSEMAN, RoleName.ADMIN],
      },
      {
        key: 'reclamation',
        path: `${APP_PREFIX_PATH}/reclamations`,
        title: 'Reklamacje',
        icon: ReconciliationOutlined,
        breadcrumb: false,
        roles: [RoleName.WAREHOUSEMAN, RoleName.ADMIN, RoleName.VENDOR],
      },
      {
        key: 'statistics',
        path: `${APP_PREFIX_PATH}/statistics`,
        title: 'Statystyki',
        icon: AreaChartOutlined,
        breadcrumb: false,
        roles: [RoleName.ADMIN],
      },
      {
        key: 'discount-code-verification',
        path: `${APP_PREFIX_PATH}/discount-codes/verify`,
        title: 'Weryfikacja kodu rabatowego',
        icon: PercentageOutlined,
        breadcrumb: false,
        roles: [RoleName.VENDOR, RoleName.WAREHOUSEMAN, RoleName.ADMIN],
      },
      {
        key: 'statusStatistics',
        path: `${APP_PREFIX_PATH}/status-statistics`,
        title: 'Nowe statystyki',
        icon: AreaChartOutlined,
        breadcrumb: false,
        roles: [RoleName.ADMIN],
      },
      {
        key: 'orderStatistics',
        path: `${APP_PREFIX_PATH}/order-statistics`,
        title: 'Statystyki zamówień',
        icon: AreaChartOutlined,
        breadcrumb: false,
        roles: [RoleName.ADMIN],
      },
    ],
  },
  {
    key: 'catalogue',
    title: 'Katalog',
    breadcrumb: false,
    roles: [RoleName.VENDOR, RoleName.WAREHOUSEMAN, RoleName.ADMIN],
    submenu: [
      {
        key: 'brands',
        path: `${APP_PREFIX_PATH}/car-brands`,
        title: 'Marki samochodów',
        icon: BankOutlined,
        breadcrumb: false,
        roles: [RoleName.VENDOR, RoleName.WAREHOUSEMAN, RoleName.ADMIN],
      },
      {
        key: 'models',
        path: `${APP_PREFIX_PATH}/car-models`,
        title: 'Modele samochodów',
        icon: BlockOutlined,
        breadcrumb: false,
        roles: [RoleName.VENDOR, RoleName.WAREHOUSEMAN, RoleName.ADMIN],
      },
      {
        key: 'cars',
        path: `${APP_PREFIX_PATH}/cars`,
        title: 'Samochody',
        icon: CarOutlined,
        breadcrumb: false,
        roles: [RoleName.VENDOR, RoleName.WAREHOUSEMAN, RoleName.ADMIN],
      },
      {
        key: 'turbines',
        path: `${APP_PREFIX_PATH}/turbines`,
        title: 'Turbiny',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        roles: [RoleName.VENDOR, RoleName.WAREHOUSEMAN, RoleName.ADMIN],
      },
      {
        key: 'applications',
        path: `${APP_PREFIX_PATH}/mobile-apps`,
        title: 'Aplikacje mobilne',
        icon: MobileOutlined,
        breadcrumb: false,
        roles: [RoleName.WAREHOUSEMAN, RoleName.ADMIN],
      },
    ],
  },
  {
    key: 'technical',
    title: 'Techniczne',
    breadcrumb: false,
    roles: [RoleName.ADMIN, RoleName.WAREHOUSEMAN, RoleName.VENDOR],
    submenu: [
      {
        key: 'users',
        path: `${APP_PREFIX_PATH}/users`,
        title: 'Użytkownicy',
        icon: UsergroupAddOutlined,
        breadcrumb: false,
        roles: [RoleName.ADMIN],
      },
      {
        key: 'shipping-addresses',
        path: `${APP_PREFIX_PATH}/shipping-addresses`,
        title: 'Adresy wysyłki',
        icon: ContainerOutlined,
        breadcrumb: false,
        roles: [RoleName.ADMIN],
      },
      {
        key: 'settings',
        path: `${APP_PREFIX_PATH}/settings`,
        title: 'Ustawienia',
        icon: SettingOutlined,
        breadcrumb: false,
        roles: [RoleName.ADMIN],
      },
      {
        key: 'margins',
        path: `${APP_PREFIX_PATH}/margins`,
        title: 'Prowizje',
        icon: DollarOutlined,
        breadcrumb: false,
        roles: [RoleName.ADMIN],
      },
      {
        key: 'discount-codes',
        path: `${APP_PREFIX_PATH}/discount-codes`,
        title: 'Kody rabatowe',
        icon: TagsOutlined,
        breadcrumb: false,
        roles: [RoleName.ADMIN],
      },
      {
        key: 'allegro-settings',
        path: `${APP_PREFIX_PATH}/allegro-settings`,
        title: 'Ustawienia allegro',
        icon: SettingOutlined,
        breadcrumb: false,
        roles: [RoleName.ADMIN, RoleName.WAREHOUSEMAN, RoleName.VENDOR],
      },
      {
        key: 'imported-products-images',
        path: `${APP_PREFIX_PATH}/imported-products-images`,
        title: 'Zdjęcia do akceptacji',
        icon: PictureOutlined,
        breadcrumb: false,
        roles: [RoleName.ADMIN, RoleName.WAREHOUSEMAN, RoleName.VENDOR],
      },
      {
        key: 'import-sync-logs',
        path: `${APP_PREFIX_PATH}/import-sync-logs`,
        title: 'Historia importów',
        icon: DatabaseOutlined,
        breadcrumb: false,
        roles: [RoleName.ADMIN],
      },
      {
        key: 'warehouses-net-price-sum',
        path: `${APP_PREFIX_PATH}/warehouses/net-price-sum`,
        title: 'Wartość magazynów',
        icon: DatabaseOutlined,
        breadcrumb: false,
        roles: [RoleName.ADMIN],
      },
    ],
  },
];

export default navigationConfig;
